import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { VatStatusView } from "./VatStatusView";
import { VatStatusViewStore } from "../../store/VatStatusViewStore";
import { useStore } from "../../../../hooks";

export const VatStatusViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/vatStatus/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new VatStatusViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <VatStatusView vatStatusViewStore={store} />
      </PageLayout>
    </div>
  );
});
